import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LexiconModule } from '@galaxy/lexicon';
import { MarketplaceAppsApiService } from '@galaxy/marketplace-apps/v1';
import { TranslateModule } from '@ngx-translate/core';
import { VaOrderFormModule } from '@vendasta/store';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../shared/constants';
import { SalesOrderStoreService } from '../sales-order-store.service';
import { SalesOrderFormComponent } from './sales-order-form.component';
import { SalesOrderFormService } from './sales-order-form.service';
import { SalesOrderService } from './sales-order.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    VaOrderFormModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
  ],
  declarations: [SalesOrderFormComponent],
  exports: [SalesOrderFormComponent],
  providers: [
    SalesOrderService,
    SalesOrderFormService,
    SalesOrderStoreService,
    { provide: 'MarketplaceAppsServiceInterface', useExisting: MarketplaceAppsApiService },
  ],
})
export class SalesOrderFormModule {}
